<!--<h2 mat-dialog-title>Comece a assinatura do plano escolhido</h2>-->
<mat-dialog-content>
  <ng-container *ngIf="!submitted; else submittedCard">
    <div style="text-align: center">
      <!-- <span class="mat-body-2">
        Use a plantaforma Colloca com tudo que ela pode te oferecer. Imprima o
        boleto e pague a qualquer momento para efetivar sua contratação do seu
        Plano. e aproveite os primeiros 30 dias grátis.
      </span> -->
      <span class="mat-body-2"> Seja bem vindo a Plataforma Colloca. </span>

      <div *ngIf="user.signature_date; else elseBlock">
        <div *ngIf="methodPay; else elseMethod">
          <div
            class="card-warn"
            *ngIf="user.signature_status !== 'ACTIVE' && this.user.signature_status !== 'TRIAL' && user.signature_id"
          >
            <p>
              Atenção!!!<br />
              Ainda não recebemos a confirmação do seu pagamento,<br />
              esse processo pode variar de acordo com o metodo de pagamento
              escolhido.
            </p>

            <a
              [href]="boletoUrl"
              target="_blank"
              class="buttonBoleto"
              *ngIf="user.payment_link"
              >Pagar</a
            >
            <button
              mat-raised-button
              class="buttonPagamento"
              (click)="viewPayment(user.email)"
            >
              Verificar Pagamento
            </button>
            <button
              mat-raised-button
              color="primary"
              class="btn-pay"
              (click)="toggleContent()"
            >
              Mudar Forma de Pagamento
            </button>
          </div>
        </div>
        <ng-template #elseMethod>
          <p>Escolha o seu plano:</p>
        </ng-template>
      </div>
      <ng-template #elseBlock>
        <p>Seu período de teste terminou!!!</p>
        <p>Escolha o seu plano:</p>
      </ng-template>
    </div>

    <ng-container *ngIf="showContent">
      <app-plan-slide
        (choosePlan)="choosePlan($event)"
        [selectedPlan]="user.signature_plan_id"
        [planType]="planType"
        [itemsPerSlide]="4"
      ></app-plan-slide>

      <ng-container *ngIf="enableVoucher">
        <div class="voucher-form-container">
          <div style="text-align: center">
            <span class="mat-title"> Cupom </span>

            <!-- <ng-container *ngIf="processListName">
            <span class="mat-body-2"
              >Use o seu cupom para acessar o processo seletivo
              {{ processListName }}</span
            >
          </ng-container> -->

            <!-- <span class="helper">
            <mat-icon>email</mat-icon>
            Acesse o número do seu cupom no último e-mail recebido do Colloca
          </span> -->
            <span class="helper" [class.success-background]="success">
              <mat-icon *ngIf="!success">email</mat-icon>
              <mat-icon *ngIf="success" style="color: #f3fff3"
                >check_circle</mat-icon
              >
              {{ message }}
            </span>
          </div>

          <form
            [formGroup]="formVoucher"
            (submit)="submitCode()"
            style="margin-top: 20px"
          >
            <div class="row">
              <mat-form-field appearance="outline" id="tourPaymentCupom">
                <mat-label>Código de cupom</mat-label>
                <input
                  type="text"
                  matInput
                  placeholder="Informe o código aqui"
                  class="voucher-code"
                  formControlName="code"
                  maxlength="8"
                  [readonly]="formVoucher.get('code').disabled"
                />
              </mat-form-field>
            </div>

            <div class="actions" *ngIf="!success">
              <button type="submit" mat-raised-button color="primary">
                Enviar Cupom
              </button>
            </div>
          </form>
        </div>
      </ng-container>

      <!-- <div class="row">
        <h5 style="text-align: center">
          OBS: Por favor, preencha todos os campos obrigatórios. A cobrança será
          gerada para o CPF informado.
        </h5>
      </div> -->

      <form [formGroup]="form" style="margin-top: 20px">
        <div class="process-list-panel">
          <div style="flex: 1" class="colum">
            <fieldset>
              <legend>Informações</legend>
            </fieldset>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Razao social</mat-label>
                <input
                  type="text"
                  placeholder="Razao social"
                  matInput
                  formControlName="companyName"
                />
                <mat-error *ngIf="form.get('companyName').errors?.required"
                  >Por favor informar a razão social</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>CNPJ</mat-label>
                <input
                  type="text"
                  placeholder="CNPJ da empresa"
                  matInput
                  formControlName="cnpj"
                  mask="00.000.000/0000-00"
                  inputmode="numeric"
                />
                <mat-error *ngIf="form.get('cnpj').errors?.required"
                  >Por favor informar o CNPJ</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input
                  type="email"
                  placeholder="Email"
                  matInput
                  formControlName="email"
                />
                <mat-error *ngIf="form.get('email').errors?.required"
                  >Por favor informar o e-mail</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Nome Completo</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Informe seu nome completo"
                  formControlName="fullname"
                />
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>CPF</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Informe seu cpf"
                  mask="000.000.000-00"
                  formControlName="cpf"
                  inputmode="numeric"
                  #focarCPF
                />
                <mat-error *ngIf="form.get('cpf').errors?.required"
                  >Por favor informar o CPF</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Data de nascimento</mat-label>
                <input
                  matInput
                  type="text"
                  mask="00/00/0000"
                  inputmode="numeric"
                  placeholder="Informe a data de nascimento"
                  formControlName="birthdate"
                />
                <mat-error *ngIf="form.get('birthdate').errors?.required"
                  >Por favor informar a data de nascimento</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Celular/whatsapp</mat-label>
                <input
                  type="text"
                  placeholder="Seu telefone"
                  matInput
                  formControlName="phone"
                  mask="(00) 00000 0000"
                  inputmode="numeric"
                />
                <mat-error *ngIf="form.get('phone').errors?.required"
                  >Por favor informar o telefone</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>CEP</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Informe seu cep"
                  formControlName="zipCode"
                  mask="00000-000"
                  inputmode="numeric"
                />
                <mat-error *ngIf="form.get('zipCode').errors?.required"
                  >Por favor informar o CEP</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Estado</mat-label>
                <mat-autocomplete
                  #autoState="matAutocomplete"
                  [displayWith]="displayState"
                  (optionSelected)="onStateSelected($event)"
                >
                  <ng-container *ngFor="let state of filteredStates$ | async">
                    <mat-option [value]="state">{{ state.nome }}</mat-option>
                  </ng-container>
                </mat-autocomplete>
                <input
                  matInput
                  type="text"
                  placeholder="Informe o estado"
                  formControlName="state"
                  [matAutocomplete]="autoState"
                />
                <mat-error *ngIf="form.get('state').errors?.required"
                  >Por favor informar o estado</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Cidade</mat-label>
                <mat-autocomplete #autoCity="matAutocomplete">
                  <ng-container *ngFor="let city of filteredCities$ | async">
                    <mat-option [value]="city.name">{{ city.name }}</mat-option>
                  </ng-container>
                </mat-autocomplete>
                <input
                  matInput
                  type="text"
                  placeholder="Informe a cidade"
                  formControlName="city"
                  [matAutocomplete]="autoCity"
                />
                <mat-error *ngIf="form.get('city').errors?.required"
                  >Por favor informar a cidade</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Bairro</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Informe seu bairro"
                  formControlName="district"
                />
                <mat-error *ngIf="form.get('district').errors?.required"
                  >Por favor informar o bairro</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Rua/avenida</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Informe a rua/avenida"
                  formControlName="street"
                />
                <mat-error *ngIf="form.get('street').errors?.required"
                  >Por favor informar a rua</mat-error
                >
              </mat-form-field>
            </div>

            <div class="row">
              <mat-form-field appearance="outline">
                <mat-label>Número de residência</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Informe número da sua residência"
                  formControlName="number"
                  inputmode="numeric"
                />
                <mat-error *ngIf="form.get('number').errors?.required"
                  >Por favor informar o número</mat-error
                >
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Complemento</mat-label>
                <input
                  matInput
                  type="text"
                  placeholder="Informe o complemento"
                  formControlName="complement"
                />
              </mat-form-field>
            </div>
          </div>
          <div style="flex: 1; padding-left: 10px">
            <fieldset><legend>Forma de Pagamento</legend></fieldset>
            <mat-tab-group (selectedTabChange)="changePaymentMethod($event)">
              <mat-tab label="Pagar no boleto">
                <div class="empty-content">
                  <p class="mat-body-2">
                    Clique no botão "continuar" prosseguir com o pagamento do
                    boleto
                  </p>
                </div>
              </mat-tab>

              <!-- <ng-container *ngIf="signaturePlan?.index > -1">
                <mat-tab label="Pagar com cartão">
                  <div class="row">
                    <mat-form-field
                      appearance="outline"
                      id="tourPaymentCardInfo"
                    >
                      <mat-label>Número do cartão de crédito</mat-label>
                      <input
                        matInput
                        type="text"
                        placeholder="Informe o número do seu cartão de crédito"
                        formControlName="cardNumber"
                        autofocus
                        maxlength="19"
                        (keyup)="onCompleteInput($event, 'holderName')"
                        mask="0000 0000 0000 0000"
                      />
                      <mat-error *ngIf="form.get('cardNumber').errors?.required"
                        >Por favor informar o nº do cartão</mat-error
                      >
                    </mat-form-field>
                  </div>

                  <div class="row">
                    <mat-form-field appearance="outline">
                      <mat-label>Bandeira do cartão</mat-label>
                      <input
                        matInput
                        type="text"
                        placeholder="Bandeira do cartão"
                        formControlName="brandCard"
                        [readonly]="true"
                      />
                      <mat-error *ngIf="form.get('brandCard').errors?.required"
                        >Por favor informar a bandeira do cartão</mat-error
                      >
                      <mat-progress-bar
                        color="primary"
                        mode="indeterminate"
                        *ngIf="submitingCardBrand"
                      ></mat-progress-bar>
                    </mat-form-field>
                  </div>

                  <div class="row">
                    <mat-form-field appearance="outline">
                      <mat-label>Nome do Titular</mat-label>
                      <input
                        matInput
                        type="text"
                        placeholder="Nome como esta no cartão"
                        formControlName="holderName"
                        id="holderName"
                      />
                      <mat-error *ngIf="form.get('holderName').errors?.required"
                        >Por favor informar o nome do titular</mat-error
                      >
                    </mat-form-field>
                  </div>

                  <div class="row">
                    <mat-form-field appearance="outline">
                      <mat-label>Data de validade</mat-label>
                      <input
                        matInput
                        type="text"
                        placeholder="Ex: 11/2030"
                        formControlName="expirationDate"
                        id="expirationDate"
                        mask="00/0000"
                        maxlength="7"
                        (keyup)="onCompleteInput($event, 'cvv')"
                      />
                      <mat-error
                        *ngIf="form.get('expirationDate').errors?.required"
                        >Por favor informar a data de validade</mat-error
                      >
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Código de segurança</mat-label>
                      <input
                        matInput
                        type="text"
                        placeholder="Codigo de segurança do cartão"
                        formControlName="cvv"
                        mask="009"
                        id="cvv"
                      />
                      <mat-error *ngIf="form.get('cvv').errors?.required"
                        >Por favor informar o código cvv</mat-error
                      >
                    </mat-form-field>
                  </div>
                </mat-tab>
              </ng-container> -->
            </mat-tab-group>
            <!-- <div class="row check">
               (change)="onAcceptEndChange($event.checked)"
              <mat-checkbox color="primary" formControlName="acceptEnd">
                quero pagar como empresa.</mat-checkbox
              >
            </div> -->
          </div>
        </div>
      </form>
    </ng-container>
  </ng-container>

  <ng-template #submittedCard>
    <div
      class="submitted-wrapper animate__animated animate__flipInY animate__fast"
    >
      <span class="mat-title" style="margin-bottom: 50px; text-align: center">
        Obrigado por assinar, estamos processando seu pagamento e retornaremos
        com resultado da operadora do seu cartão
      </span>

      <img src="assets/images/hourglass.png" />
    </div>
  </ng-template>
</mat-dialog-content>
<mat-progress-bar
  mode="indeterminate"
  color="primary"
  *ngIf="submiting"
></mat-progress-bar>
<mat-dialog-actions *ngIf="!submiting && !submitted">
  <!-- <button *ngIf="paymentMethod === 'CREDIT_CARD'"  mat-button color="accent" mat-dialog-close id="tourPaymentNext">Fechar</button> -->
  <div *ngIf="showContent; else elseshowContent">
    <button
      mat-raised-button
      color="primary"
      (click)="submit()"
      [disabled]="form.invalid"
    >
      Continuar
    </button>
  </div>
  <ng-template #elseshowContent>
    <button mat-raised-button color="warn" (click)="logout()">
      Sair da Conta
    </button>
  </ng-template>
  <!-- <ng-container *ngIf="user['account_type'] == 'company'">
        <button mat-button color="accent" mat-dialog-close (click)="makeFreeAccount()" id="tourPaymentNext">
            Continuar com plano gratuito
        </button>
    </ng-container> -->
</mat-dialog-actions>
